<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { http } from '@/shared/httpWrapper';
    import { ClientApplicationStats, getClientApplications } from '@/shared/helpers/api';
    import { formatBigNumber } from '@/formatters';
    import { getClientApplicationDetailsLink } from '@/shared/helpers/routing';
    import UsageStatsBackLink from './UsageStatsBackLink.vue';

    const apps = ref<ClientApplicationStats[]>([]);
    const loading = ref(false);

    async function load(): Promise<void> {
        try {
            loading.value = true;
            apps.value = await getClientApplications(http);
        } finally {
            loading.value = false;
        }
    }

    onMounted(load);
</script>

<template>
    <div>
        <h1 class="title">
            Client Applications
        </h1>
        <h2 class="subtitle mb-1">
            Resource usage overview by registered CommonLibrary clients
        </h2>
        <usage-stats-back-link />
        <hr>
        <b-table
            :data="apps"
            :loading="loading"
            default-sort="countThisMonth"
            default-sort-direction="desc"
            :narrowed="true"
            :hoverable="true"
            :striped="true">
            <b-table-column
                v-slot="props"
                field="description"
                label="Description"
                :searchable="true"
                sortable>
                <router-link :to="getClientApplicationDetailsLink(props.row.userId)">
                    {{ props.row.description }}
                </router-link>
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="countToday"
                label="Today"
                numeric
                sortable>
                {{ formatBigNumber(props.row.countToday) }}
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="countThisMonth"
                label="This month"
                numeric
                sortable>
                {{ formatBigNumber(props.row.countThisMonth) }}
            </b-table-column>
            <b-table-column
                v-slot="props"
                field="countPrevMonth"
                label="Prev month"
                numeric
                sortable>
                {{ formatBigNumber(props.row.countPrevMonth) }}
            </b-table-column>
        </b-table>
    </div>
</template>
